export const AUTH_TOKEN = 'token';
export const REFRESH_TOKEN = 'refresh_token';
export const USER_ID = 'user_id';
export const USER_NAME = 'user_name';
